import { FontAwesome } from "@expo/vector-icons";
import React from "react";

export default function TabBarIcon(props: {
  name: React.ComponentProps<typeof FontAwesome>["name"];
  size?: number;
  color: string;
}) {
  return <FontAwesome size={props.size || 30} style={{ marginTop: 3, alignItems: "center", justifyContent: "center", alignSelf: "center", }} {...props} />;
}
